import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@openedx/paragon';
import { FormattedMessage, useIntl } from '@edx/frontend-platform/i18n';

import emptyWishlistSVG from '../../../assets/empty-wishlist.svg';
import messages from '../messages';

const WishlistEmpty = () => {
  const { formatMessage } = useIntl();
  return (
    <div className="wishlist-page__empty">
      <img
        src={emptyWishlistSVG}
        alt={formatMessage(messages.emptyImageAlt)}
        className="wishlist-page__empty-image"
      />
      <div className="wishlist-page__empty-text">
        <h3 className="wishlist-page__empty-title">
          <FormattedMessage {...messages.emptyTitle} />
        </h3>
        <Button as={Link} to="/discover" variant="primary">
          <FormattedMessage {...messages.emptyCta} />
        </Button>
      </div>
    </div>
  );
};

export default WishlistEmpty;
